import {
    AccountsAction,
    BookingAction,
    CustomerAction,
    DashboardAction,
    InventoryAction,
    RestaurantAction,
    SalesPurchaseAction,
    StockActions,
    UtilitiesAction,
} from "../contants/Modules.Action.Type";

const inventoryState = {
  Products: [],
  Category: [],
  Godown: [],
  Brands: [],
    Ingredients:[],
};
export const inventoryReducer = (state = inventoryState, { type, payload }) => {
  switch (type) {
    case InventoryAction.SET_INVENTORY_PRODUCTS:
      return { ...state, Products: payload.Products };
    case InventoryAction.SET_INVENTORY_CATEGORY:
      return { ...state, Category: payload.Category };
    case InventoryAction.SET_INVENTORY_GODOWN:
      return { ...state, Godown: payload.Godown };
    case InventoryAction.SET_INVENTORY_BRANDS:
      return { ...state, Brands: payload.Brand };
      case InventoryAction.SET_INVENTORY_PRODUCT_INGREDIENT:
      return { ...state, Ingredients: payload.Ingredient };
    default:
      return state;
  }
};

const utilitiesState = {
  Employee: [],
  Users: [],
  Roles: [],
};
export const utilitiesReducer = (state = utilitiesState, { type, payload }) => {
  switch (type) {
    case UtilitiesAction.SET_UTILITIES_EMPLOYEE:
      return { ...state, Employee: payload.Employee };
    case UtilitiesAction.SET_UTILITIES_USERS:
      return { ...state, Users: payload.Users };
    case UtilitiesAction.SET_UTILITIES_ROLES:
      return { ...state, Roles: payload.Roles };
    default:
      return state;
  }
};

const restaurantState = {
  TableList: [],
  TableGroup: [],
};
export const restaurantReducer = (
  state = restaurantState,
  { type, payload }
) => {
  switch (type) {
    case RestaurantAction.SET_NEW_TABLE_LIST:
      return { ...state, TableList: payload.TableList };
    case RestaurantAction.SET_NEW_TABLE_GROUP:
      return { ...state, TableGroup: payload.TableGroup };
    default:
      return state;
  }
};

const customerState = {
  CustomerList: [],
  Membership: [],
  Discount: [],
  Promo: [],
};
export const customerReducer = (state = customerState, { type, payload }) => {
  switch (type) {
    case CustomerAction.SET_CUSTOMER_LIST:
      return { ...state, CustomerList: payload.CustomerList };
    case CustomerAction.SET_MEMBERSHIP:
      return { ...state, Membership: payload.Membership };
    case CustomerAction.SET_DISCOUNT:
      return { ...state, Discount: payload.Discount };
    case CustomerAction.SET_PROMOCODE:
      return { ...state, Promo: payload.Promo };
    default:
      return state;
  }
};

const AccountsState = {
  AccountHead: [],
  AccountGroup: [],
  GroupCategory: [],
  PartyRate: [],
};
export const accountReducer = (state = AccountsState, { type, payload }) => {
  switch (type) {
    case AccountsAction.SET_ACCOUNT_HEAD:
      return { ...state, AccountHead: payload.AccountHead };
    case AccountsAction.SET_ACCOUNT_GROUP:
      return { ...state, AccountGroup: payload.AccountGroup };
    case AccountsAction.SET_GROUP_CATEGORY:
      return { ...state, GroupCategory: payload.GroupCategory };
    case AccountsAction.SET_PARTY_RATE:
      return { ...state, PartyRate: payload.PartyRate };
    default:
      return state;
  }
};

const SalesPurchase = {
  Sales: {
    account: [],
    date: new Date(),
    route: "",
    type: "Estimate",
    payment: "Credit",
    AmountReceive: 0,
    vehicle: "",
    rate: "Retail",
    particulars: [],
    netAmount: 0,
    tax: 0,
    taxAmount: 0,
    grandTotal: 0,
    remark: "",
    docs: [],
  },
  Purchase: [],
};

export const SalesPurchaseReducer = (
  state = SalesPurchase,
  { type, payload }
) => {
  switch (type) {
    case SalesPurchaseAction.ADD_PARTICULAR:
      return { ...state, Sales: payload.Sales };
    case SalesPurchaseAction.REMOVE_SALES_PARTICULAR:
      return { ...state, Sales: payload.Sales };
    case SalesPurchaseAction.SALES_TOTAL_CALCULATION:
      return { ...state, Sales: payload };
    case SalesPurchaseAction.SALES_CHANGE_HANDLER:
      return { ...state, Sales: payload.Sales };
    case SalesPurchaseAction.SALES_RATE_CHANGE:
      return { ...state, Sales: payload.Sales };
    case SalesPurchaseAction.SALES_SET_TO_DEFAULT:
      return { ...state, Sales: payload.Sales };
    default:
      return state;
  }
};
const Stock = {
  Entry: {
    date: "",
    note: "",
    employee: "",
    particulars: [],
  },
};
export const StockReducer = (state = Stock, { type, payload }) => {
  switch (type) {
    case StockActions.STOCK_PARTICULAR:
      return { ...state, Entry: payload.Entry };
    case StockActions.REMOVE_STOCK_PARTICULAR:
      return { ...state, Entry: payload.Entry };
    case StockActions.STOCK_CHANGE_HANDLER:
      return { ...state, Entry: payload.Entry };
    case StockActions.SET_STOCK_TO_DEFAULT:
      return { ...state, Entry: payload.Entry };
    default:
      return state;
  }
};

const Booking = {
  Booking: {
    customer: [],
    Ddate: new Date(),
    type: "storepick",
    payment: "COD",
    Daddress: "",
    Dcontact: "",
    landmark: "",
    sameAsOrder: true,
    particulars: [],
    netAmount: 0,
    delivery: 0,
    advance: 0,
    tax: 0,
    taxAmount: 0,
    grandTotal: 0,
    remark: "",
    docs: [],
  },
};

export const BookingReducer = (state = Booking, { type, payload }) => {
  switch (type) {
    case BookingAction.BOOKING_ADD_PARTICULAR:
      return { ...state, Booking: payload.Booking };
    case BookingAction.REMOVE_BOOKING_PARTICULAR:
      return { ...state, Booking: payload.Booking };
    case BookingAction.BOOKING_TOTAL_CALCULATION:
      return { ...state, Booking: payload.Booking };
    case BookingAction.BOOKING_CHANGE_HANDLER:
      return { ...state, Booking: payload.Booking };
    case BookingAction.BOOKING_SET_TO_DEFAULT:
      return { ...state, Booking: payload.Booking };
    default:
      return state;
  }
};

const Dashboard = {
  orderSummary: false,
  statistics: false,
  todayInfo: false,
  transactions: false,
  stockUpdate: false,
};
export const DashboardReducer = (state = Dashboard, { type, payload }) => {
  switch (type) {
    case DashboardAction.SET_ORDER_SUMMARY:
      return { ...state, orderSummary: payload.orderSummary };
    case DashboardAction.SET_STATISTICS:
      return { ...state, statistics: payload.statistics };
    case DashboardAction.SET_TODAYINFO:
      return { ...state, todayInfo: payload.todayInfo };
    case DashboardAction.SET_TRANSACTIONS:
      return { ...state, transactions: payload.transactions };
    case DashboardAction.SET_STOCK_UPDATE:
      return { ...state, stockUpdate: payload.stockUpdate };
    default:
      return state;
  }
};
